var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.customFieldGroups, function (grp) {
      return _c("CustomFieldGroup", {
        key: "cfg-" + grp.group,
        attrs: {
          "custom-field-group": grp,
          "group-values": _vm.localValue[grp.group] || {},
        },
        on: { changed: _vm.handleCustomFieldGroupChanged },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }